export default {
  baseUrl: "",
}
